export class ResponseModel<T>{
    data: T;
    errors: String[];
}